
  export const sanityAssets = {};
  